import React, { Component, useEffect, useState } from 'react';
import { isHebrew } from '../../../App';
import { makeStyles } from '@material-ui/core/styles';

import { Box, Grid, Typography } from '@material-ui/core';
import { BodyText, HeadingText } from './TextHelpers';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';

import BriefCaseIcon from '../images/briefcase_icon.svg';
import EventsIcon from '../images/events_icon.svg';
import MarketingIcon from '../images/marketing_icon.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#0e091e',
    minHeight: '100vh',
  },
  hero: {
    minHeight: '70vh',
  },
}));

const bulletsJsonIcons = [MarketingIcon, EventsIcon, BriefCaseIcon];
const bulletsJsonTitles = ['Marketing', 'Events', 'Custom'];
const bulletsJsonDetails = [
  'Drive brand awareness and convert customers by leveraging the right celebrity spokesperson for custom content to represent your brand for campaigns, bespoke partnerships, collaboration + more.',
  'Your next event is important to you, but how can it stay within your budget? KRE8.TV videos are the most economical way to provide an engaging experience for attendees and guests',
  'We’ll create custom engagements to meet your needs. Customizing celebrity appearances can be tough. Let us do the all of the work for you!',
];

const bulletsJsonTitles_hebrew = ['שיווק', 'אירועים', 'הזדמנוית מכירות'];
const bulletsJsonDetails_hebrew = [
  'הגבירו את המודעות למותג והפכו את הלקוחות על ידי מינוף הדובר הנכון של סלבריטאים לתוכן מותאם אישית לייצוג המותג שלכם לקמפיינים ולשותפויות מותאמות.',
  'הפוך את האירועים שלך למרתקים, מרשימים ובלתי נשכחים יותר על ידי שימוש בסרטוני KRE8.TV לצעקות, הכרזות והזמנת ידוענים כדוברים, מנחים וכמבצעים.',
  'ארגן הזמנות מפורסמות בהתאמה אישית כגון שותפויות מעמיקות במותג, מתנות לעובדים וצעקות, תוכן מכירות וכו',
];

const Bullet = (props) => {
  const classes = useStyles({ isHebrew: isHebrew() });
  const { icon, title, detail } = props;
  return (
    <Box display="flex" flexDirection="row">
      <Box id="bullet-icon-container" color="white">
        {icon}
      </Box>
      <Box id="bullet-text-container" pl={1.5} pr={1.5}>
        <HeadingText fontSize="18px" mt={0.5}>
          {title}
        </HeadingText>
        <BodyText fontSize="16px" mt={1}>
          {detail}
        </BodyText>
      </Box>
    </Box>
  );
};

export const BulletsSection = () => {
  const titles = isHebrew() ? bulletsJsonTitles_hebrew : bulletsJsonTitles;
  const details = isHebrew() ? bulletsJsonDetails_hebrew : bulletsJsonDetails;
  return (
    <Box display="flex" flexDirection="row" mb={4}>
      <Grid container spacing={2}>
        {titles.map((item, index) => {
          return (
            <Grid item xs="12" sm="12" md="4">
              <Bullet
                icon={
                  <img
                    src={bulletsJsonIcons[index]}
                    alt="bullet"
                    style={{ width: '32px', height: '32px' }}
                  />
                }
                title={titles[index]}
                detail={details[index]}
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
